import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=67f71fa3&scoped=true&"
import script from "./settings.ts?vue&type=script&lang=ts&"
export * from "./settings.ts?vue&type=script&lang=ts&"
import style0 from "./settings.scss?vue&type=style&index=0&id=67f71fa3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f71fa3",
  null
  
)

export default component.exports